define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/ApplicantRole", "../../utils/StringUtil", "../domain"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, ApplicantRole_1, StringUtil_1, domain_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Applicant = void 0;
    class Applicant extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "ApplicationId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicationIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Name", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NameSearchIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NameSearchIndexError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostalAddress_1", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostalAddress_1Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostalAddress_2", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostalAddress_2Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Town", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TownError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "State", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Postcode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PostcodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ResidentialAddress", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ResidentialAddressError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PhoneLandline", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PhoneLandlineError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PhoneMobile", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PhoneMobileError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Fax", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FaxError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Email", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EmailError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EnableNotifications", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EnableNotificationsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicantRole", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedApplicantRole", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicantRoleError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitApplication", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, Applicant.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PermitApplication = parent;
            this.ApplicationId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.ApplicantRole = [];
        }
        onRead(entity, parent) {
            this.PermitApplication = parent;
            this.ApplicantRole = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.ApplicationId = (0, EntityUtil_1.toInt)(entity.ApplicationId);
            a.Name = b.Name;
            a.NameSearchIndex = b.NameSearchIndex;
            a.PostalAddress_1 = b.PostalAddress_1;
            a.PostalAddress_2 = b.PostalAddress_2;
            a.Town = b.Town;
            a.State = b.State;
            a.Postcode = b.Postcode;
            a.ResidentialAddress = b.ResidentialAddress;
            a.PhoneLandline = b.PhoneLandline;
            a.PhoneMobile = b.PhoneMobile;
            a.Fax = b.Fax;
            a.Email = b.Email;
            a.EnableNotifications = (0, EntityUtil_1.toInt)(entity.EnableNotifications);
            a.ApplicantRole = this.mergeArray(a.ApplicantRole, b.ApplicantRole, ApplicantRole_1.ApplicantRole);
            a.SelectedApplicantRole = a.SelectedApplicantRole && a.ApplicantRole.find(x => x.Id == a.SelectedApplicantRole.Id) ? a.SelectedApplicantRole : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, Applicant.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (this.EnableNotifications == 1) {
                    this.EmailError = (this.Email == null || !StringUtil_1.StringUtil.isEmail(this.Email)) ? "Email is required" : null;
                    if (this.EmailError != null) {
                        validationState.addError(this.EmailError);
                    }
                }
                this.PhoneLandlineError = this.PhoneLandline == null || !StringUtil_1.StringUtil.IsPhoneNumber(this.PhoneLandline) ? "A valid Preferred Contact Number is required" : null;
                if (this.PhoneLandlineError != null) {
                    validationState.addError(this.PhoneLandlineError);
                }
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqString(validationState, "Name", "Name");
                this.validateReqString(validationState, "PostalAddress_1", "Postal Address Line 1");
                this.validateReqString(validationState, "Town", "Town");
                this.validateReqString(validationState, "State", "State");
                this.validateReqString(validationState, "Postcode", "Postcode");
                this.validateReqString(validationState, "PhoneLandline", "Preferred Contact Number");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.ApplicantRole) {
                for (let x of this.ApplicantRole) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                ApplicationId: this.ApplicationId,
                Name: this.Name,
                NameSearchIndex: this.NameSearchIndex,
                PostalAddress_1: this.PostalAddress_1,
                PostalAddress_2: this.PostalAddress_2,
                Town: this.Town,
                State: this.State,
                Postcode: this.Postcode,
                ResidentialAddress: this.ResidentialAddress,
                PhoneLandline: this.PhoneLandline,
                PhoneMobile: this.PhoneMobile,
                Fax: this.Fax,
                Email: this.Email,
                EnableNotifications: this.EnableNotifications,
                ApplicantRole: this.ApplicantRole.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(pa) {
            return new Promise((resolve, reject) => {
                let a = new Applicant(null, pa);
                a.Name = "";
                pa.Applicant.push(a);
                resolve(a);
            });
        }
        get IsApplicant() {
            let r = this.inferApplicantRoleFromApplication(domain_1.ApplicantTypeDomain.Applicant);
            return r != null && r.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION;
        }
        get IsOwner() {
            let r = this.inferApplicantRoleFromApplication(domain_1.ApplicantTypeDomain.Owner);
            return r != null && r.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION;
        }
        get IsDrover() {
            let r = this.inferApplicantRoleFromApplication(domain_1.ApplicantTypeDomain.Drover);
            return r != null && r.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION;
        }
        inferApplicantRoleFromApplication(roleType) {
            for (let applicantRole of this.ApplicantRole) {
                if (applicantRole.ApplicantType == roleType) {
                    return applicantRole;
                }
            }
            return null;
        }
        toggleApplicantRole(isRoleApplicable, roleType) {
            var binding = null;
            console.log(isRoleApplicable, roleType);
            if (isRoleApplicable) {
                binding = this.inferApplicantRoleFromApplication(roleType);
                console.log(binding);
                if (binding == null) {
                    binding = new ApplicantRole_1.ApplicantRole(null, this);
                    binding.ApplicantType = roleType;
                    this.ApplicantRole.push(binding);
                }
                else {
                    if (binding.PersistanceState == EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                        binding.PersistanceState = binding.PersistanceStateBeforeDelete;
                    }
                    else {
                        throw new Error("Applicant binding should have had a state == Delete");
                    }
                }
            }
            else {
                binding = this.inferApplicantRoleFromApplication(roleType);
                console.log(binding);
                if (binding != null) {
                    if (binding.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                        let indexToRemove = this.ApplicantRole.findIndex((r) => r.Id == binding.Id);
                        console.log(indexToRemove);
                        if (indexToRemove > -1) {
                            this.ApplicantRole.splice(indexToRemove, 1);
                        }
                        else {
                            throw new Error("Applicant Role binding should exist");
                        }
                    }
                    else {
                        binding.markForDeletion();
                    }
                }
                else {
                    throw new Error("Applicant Role binding should exist");
                }
            }
            if (roleType == domain_1.ApplicantTypeDomain.Drover) {
                let drovers = this.PermitApplication.DroverApplicants;
                console.log("Check TP Primary Drovers", drovers);
                for (let p of this.PermitApplication.Permit.filter(x => x.PermitType == domain_1.PermitTypeDomain.TravelPermit)) {
                    let resetDrover = true;
                    if (p.TravelPermit.DroverId && p.TravelPermit.DroverId != this.PermitApplication.NO_DROVER_ID) {
                        let d = drovers.findByKey(p.TravelPermit.DroverId);
                        console.log(d);
                        console.log(d == null);
                        resetDrover = d == null;
                    }
                    if (resetDrover) {
                        if (drovers.length > 0) {
                            p.TravelPermit.DroverId = drovers.Values[0].key;
                        }
                        else {
                            p.TravelPermit.DroverId = this.PermitApplication.NO_DROVER_ID;
                        }
                    }
                }
            }
            console.log(this.ApplicantRole);
        }
    }
    exports.Applicant = Applicant;
    Object.defineProperty(Applicant, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Applicant"
    });
    Object.defineProperty(Applicant, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Permit Application Applicants"
    });
    Object.defineProperty(Applicant, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "ApplicationId", "Name", "NameSearchIndex", "PostalAddress_1", "PostalAddress_2", "Town", "State", "Postcode", "ResidentialAddress", "PhoneLandline", "PhoneMobile", "Fax", "Email", "EnableNotifications"]
    });
    Object.defineProperty(Applicant, "ApplicationIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Applicant, "NameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(Applicant, "NameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Applicant, "NameSearchIndexLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(Applicant, "NameSearchIndexReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Applicant, "PostalAddress_1Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 256
    });
    Object.defineProperty(Applicant, "PostalAddress_1Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Applicant, "PostalAddress_2Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 256
    });
    Object.defineProperty(Applicant, "PostalAddress_2Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Applicant, "TownLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 40
    });
    Object.defineProperty(Applicant, "TownReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Applicant, "StateLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(Applicant, "StateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Applicant, "PostcodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(Applicant, "PostcodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Applicant, "ResidentialAddressLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 512
    });
    Object.defineProperty(Applicant, "ResidentialAddressReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Applicant, "PhoneLandlineLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 15
    });
    Object.defineProperty(Applicant, "PhoneLandlineReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Applicant, "PhoneMobileLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 15
    });
    Object.defineProperty(Applicant, "PhoneMobileReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Applicant, "FaxLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 12
    });
    Object.defineProperty(Applicant, "FaxReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Applicant, "EmailLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100
    });
    Object.defineProperty(Applicant, "EmailReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(Applicant, "EnableNotificationsTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Does this applicant wish to receive email notifications when another applicant has been given a permit to graze or travel in the vicinity of this permit?"
    });
    Object.defineProperty(Applicant, "EnableNotificationsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "ApplicationId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "ApplicationIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "Name", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "NameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "NameSearchIndex", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "NameSearchIndexError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PostalAddress_1", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PostalAddress_1Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PostalAddress_2", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PostalAddress_2Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "Town", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "TownError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "State", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "StateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "Postcode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PostcodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "ResidentialAddress", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "ResidentialAddressError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PhoneLandline", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PhoneLandlineError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PhoneMobile", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PhoneMobileError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "Fax", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "FaxError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "Email", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "EmailError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "EnableNotifications", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "EnableNotificationsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "ApplicantRole", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "SelectedApplicantRole", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "ApplicantRoleError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Applicant.prototype, "PermitApplication", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Applicant.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Applicant.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Applicant.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Applicant.prototype, "IsApplicant", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Applicant.prototype, "IsOwner", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], Applicant.prototype, "IsDrover", null);
});
